<template>
	<section class="main-box">
		<el-tabs v-model="tabsObj" class="tabBox" @tab-click="tabClick">
			<el-tab-pane label="方案管理" name="first">
				<!--工具条-->
        <el-row>
          <el-col :span="24">
            <el-form :inline="true" :model="filters" ref="param">
              <el-form-item label="项目">
                  <ProjectList @proSelected="proChange"></ProjectList>
              </el-form-item>
              <el-form-item label="时间">
                <el-date-picker
                  v-model="filters.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-input v-model="filters.searchTab" placeholder="按名称搜索" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" v-on:click="doSearch()">查询</el-button>
                <el-button v-on:click="showAddView()" type="success">添加</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!--列表-->
        <template>
          <el-table :data="data" highlight-current-row v-loading="loading">
            <el-table-column type="index" label="序号" width="100" align="center">
            </el-table-column>
            <el-table-column prop="dataName" label="名称" align="center" :label="this.GLOBAL.filePath">
              <template slot-scope="scope">
                <a href="javascript:void(0)" @click="downloadFile(scope.row.dataPath)" class="download"  title="下载附件">{{scope.row.dataName}}</a>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="导入时间" align="center" :formatter="formatDate">
            </el-table-column>
            <el-table-column label="操作" width="251" align="center">
              <template slot-scope="scope">
                <!--            <el-button size="small" @click="openDetails(scope.$index, scope.row)">查看</el-button>-->
                <el-button size="small" @click="showEditView(scope.$index, scope.row)">编辑</el-button>
                <el-button type="danger" size="small" @click="doDel(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--工具条-->
          <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total" class="layout-right">
            </el-pagination>
          </el-col>
        </template>
			</el-tab-pane>
			<el-tab-pane label="检测资料" name="second">
        <!--工具条-->
        <el-row>
          <el-col :span="24">
            <el-form :inline="true" :model="filters" ref="param">
              <el-form-item label="项目">
                <ProjectList @proSelected="proChange"></ProjectList>
              </el-form-item>
              <el-form-item label="时间">
                <el-date-picker
                  v-model="filters.time"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-input v-model="filters.searchTab" placeholder="按名称搜索" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" v-on:click="doSearch()">查询</el-button>
                <el-button v-on:click="showAddView()" type="success">添加</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <!--列表-->
        <template>
          <el-table :data="data" highlight-current-row v-loading="loading">
            <el-table-column type="index" label="序号" width="100" align="center">
            </el-table-column>
            <el-table-column prop="dataName" label="名称" align="center" :label="this.GLOBAL.filePath">
              <template slot-scope="scope">
                <a href="javascript:void(0)" @click="downloadFile(scope.row.dataPath)" class="download"  title="下载附件">{{scope.row.dataName}}</a>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="导入时间" align="center" :formatter="formatDate">
            </el-table-column>
            <el-table-column label="操作" width="251" align="center">
              <template slot-scope="scope">
                <!--            <el-button size="small" @click="openDetails(scope.$index, scope.row)">查看</el-button>-->
                <el-button size="small" @click="showEditView(scope.$index, scope.row)">编辑</el-button>
                <el-button type="danger" size="small" @click="doDel(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--工具条-->
          <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total" class="layout-right">
            </el-pagination>
          </el-col>
        </template>
			</el-tab-pane>
		</el-tabs>
    <!-- 表单视图 -->
    <el-dialog title="" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false">
      <div v-if="formVisible">
<!--        <EnclosureDataForm :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-data="formData" :type="encType"> </EnclosureDataForm>-->
        <EncDataForm :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-data="formData" :type="encType"></EncDataForm>
      </div>
    </el-dialog>
	</section>
</template>
<script>
  import {proSearch,dataDel,dataSearch,dataDetail} from '../../api/api'
  import EncDataForm from "../command/EncDataForm";
  import ProjectList from "../command/ProjectList";
  export default {
    components: {ProjectList, EncDataForm},
    data() {
      return {
        tabsObj:'first',
        filters: {proId:null,},
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        loading: false,
        total: 2,
        page: 1,
        limit:15,
        data: [],
        formData:{},
        encType:1,
        formVisible:false,
        detailId:null,
        proList:[],
      }
    },
    methods: {
      //查询
      searchData:function(){
        this.GLOBAL.checkRole(this.GLOBAL.fun.deviceEnc, this.GLOBAL.option.select, this);
        this.loading = true;
        this.filters.page = this.page;
        this.filters.limit=this.limit;//请求参数
        if(this.filters.searchTab==''){
          this.filters.searchTab = null;
        }
        let rangTime = this.filters.time+"";
        let beginTime=null,endTime=null;
        if(rangTime)
        {
          beginTime = rangTime.split(",")[0];
          beginTime =  new Date(beginTime);
          endTime = rangTime.split(",")[1];
          endTime =  new Date(endTime);
        }
        this.filters.beginTime = beginTime;
        this.filters.endTime = endTime;
        this.filters.type=this.encType;
        this.filters.proId = this.filters.proId == '' ? null : this.filters.proId;
        this.filters.comId = this.GLOBAL.user.comId;
        dataSearch(this.filters,this.GLOBAL.header).then(result => {
          if(result.success) {
            this.data = result.data.result;
            this.total = result.data.total;
            this.loading = false;
          }
        });
      },
      doSearch:function(){
        this.searchData()
      },
      resetForm:function(){
        this.filters={}
      },
      searchPage:function(val){
        this.page = val;
        this.searchData();
      },
      formatDate:function(row, column){
        return this.GLOBAL.formatTimeToStr(row.createTime,"yyyy-MM-dd hh:mm:ss");
      },
      //========================================
      //添加视图
      showAddView:function(){
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.deviceEnc, this.GLOBAL.option.create, this);
        if (res) {
          this.option = 0;
          this.formData = {}
          this.formVisible = true;
        }
      },
      //编辑视图
      showEditView:function(index,row){
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.deviceEnc, this.GLOBAL.option.update, this);
        if (res) {
          this.option = 1;
          this.detailId = row.id;
          dataDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;

              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        this.formVisible = false;
      },
      //表单取消后回调
      doCancel: function () {
        this.formVisible = false;
      },
      //删除
      doDel:function(index,row){
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.deviceEnc, this.GLOBAL.option.delete, this);
        if (res) {
          this.$confirm('确认删除该记录吗?', '提示', {
            type: 'warning'
          }).then(() => {
            dataDel({id: row.id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: "删除成功",
                  type: 'success'
                });
                this.searchData();
              }
            });
          }).catch(() => {
          });
        }
      },
      //=====下载文件方法====================================================
      downloadFile:function(file){
        if(file!=null && file!='') {
          let url = this.GLOBAL.baseFilePath + file;    // 获取图片地址
          let a = document.createElement('a');          // 创建一个a节点插入的document
          let event = new MouseEvent('click')       // 模拟鼠标click点击事件
          a.download = 'beautifulGirl'                  // 设置a节点的download属性值
          a.href = url;                                 // 将图片的src赋值给a节点的href
          a.dispatchEvent(event)                        // 触发鼠标点击事件
        }
      },
      tabClick:function(tab){
        if(tab.index==0)
        {
          this.encType=1;
          this.searchData();
        }else {
          this.encType=2;
          this.searchData();
        }
      },
      proChange:function(proId){
        this.filters.proId = proId;
        this.doSearch();
      }
    },
    mounted() {

    }
  };
</script>
<style scoped>
  .download{
    text-decoration: none;
    color:blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/Material.vue